import { createFileRoute } from '@tanstack/react-router';
import { BookmarksSkeleton } from 'components/pages/bookmarks/skeleton';
import { lazy, Suspense } from 'react';

const Bookmarks = lazy(() => import('pages/bookmarks'));

export const Route = createFileRoute('/_authenticated/_main/bookmarks')({
  component: BookmarksWrapper,
});

function BookmarksWrapper() {
  return (
    <Suspense fallback={<BookmarksSkeleton />}>
      <Bookmarks />
    </Suspense>
  );
}
